(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["br-ortiga-main"] && !Shopify.designMode) return;
  try {
    
  const initBrPdp = (root) => {
    if (!root || root.dataset.brReady === 'true') return;
    root.dataset.brReady = 'true';
    root.querySelectorAll('[data-br-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const index = button.dataset.brThumb;
        root.querySelectorAll('[data-br-thumb]').forEach((item) => item.classList.toggle('is-active', item === button));
        root.querySelectorAll('[data-br-media]').forEach((media) => media.classList.toggle('br-pdp__media--hidden', media.dataset.brMedia !== index));
      });
    });
    const mainButton = root.querySelector('[data-br-main-cta]');
    const stickyButton = root.querySelector('[data-br-sticky-button]');
    if (stickyButton && mainButton) stickyButton.addEventListener('click', () => mainButton.click());
  };
  document.querySelectorAll('[data-br-section]').forEach(initBrPdp);
  document.addEventListener('shopify:section:load', (event) => initBrPdp(event.target.querySelector('[data-br-section]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
